export default __webpack_public_path__ + "images/e075c0d7df0d1a6a5cb94b45a0a29aa0.svg";